import React, { useState } from 'react'
import styles from '../styles/dialogApply.module.scss'
import { useGetBalanceData } from '@/api/request'
import SpriteContainer from '@/wmCompoments/spriteContainer'
import { useAuth } from '@/provides/authProvider'
import { useVenueRecycle } from '../hooks/useInviteFriends'
import { useModal } from '@/modals/modalContext'
import cs from 'classnames'
import SwiperUI from './swiperUI'
import Toast from '@/wmCompoments/toast'
import ErrorMessageDialog from '@/antComponent/errorMessageDialog'
import { useTranslation } from 'react-i18next'

const DialogApply = (props) => {
  const { token }=useAuth()
  const { openModal } = useModal()
  const { t } = useTranslation('inviteFriends')
  const { bonusType, venueList, prizeTypeList, isLoading, onSelectBonusRetry, onSelectVenuRetry, onChangePriceRetry, price, activeBonus, activeVenus } = props
  
  const [prices, setPrice] = useState(prizeTypeList?.[0]?.depositAmount ?? 0)
  // 回收
  const { isMutating: isLoadingRecyle, trigger: triggerVenueRecycle } = useVenueRecycle()
  // 获取可用余额
  const { isValidating, data: blanceData, mutate: refreshBalance } = useGetBalanceData()
  
  // 一键回收
  const onVenueRecyle = async () => {
    if (!token) {
      openModal('login', { mode: 'invite' }) 
      return
    }
    try {
      await triggerVenueRecycle({})
      await refreshBalance()
      Toast.show(t('dialogApply.recycleSuccess'))
    } catch (err: any) {
      ErrorMessageDialog(err?.message ?? JSON.stringify(err))
    }
  }
  // 刷新余额
  const onRefreshBalanceContent = async () => {
    if (!token) {
      openModal('login', { mode: 'invite' }) 
      return;
    }
    try {
      await refreshBalance();
      Toast.show(t('dialogApply.refreshSuccess'));
    } catch (err: any) {
      ErrorMessageDialog(err?.message ?? JSON.stringify(err))
    }
  };

  return <div className={styles.dialogApply}>
    {/* 顶部余额、回收 */}
    <div className={styles.top}>
      <div>
        <div className={styles.wallet}>{t('dialogApply.centralWallet')}</div>
        <div className={styles.balance}>
          <span>¥{blanceData?.centerWalletBalance}</span>
          <SpriteContainer name={'icon_refresh_night'} onClick={onRefreshBalanceContent} module={'wallet'} />
        </div>
      </div>
      <button onClick={onVenueRecyle} >{t('dialogApply.oneClickRecycle')}</button>
    </div>

    {/* 选择领取礼金 */}
    <div className={styles.bonus}>
      <div className={styles.title}>{t('dialogApply.pleaseSelectBonus')}</div>
      <SwiperUI
        data={prizeTypeList}
        slidesPerView={1.4} // 每次页面显示几个滑块
        handleSlideChangeRetry={(i) => { 
          onSelectBonusRetry(i) 
          setPrice(prizeTypeList[i]?.depositAmount) // 滑动改变input的值
        }}
        renderChildren={(v,index) => (
          <div 
            className={cs(styles.item, styles.item_bonus, (index === activeBonus) && styles.item_active)}
            onClick={() => {onSelectBonusRetry(index)
            setPrice(v?.depositAmount)
          }}>{v.title}</div>
        )}
      />
    </div>

    {/* 选择领取场馆 */}
    <div className={styles.venue}>
      <div className={styles.title}>{t('dialogApply.pleaseSelectVenue')}</div>
      <SwiperUI
        data={venueList}
        slidesPerView={3.2} // 每次页面显示几个滑块
        handleSlideChangeRetry={(i) => { onSelectVenuRetry(i) }}
        renderChildren={(v,index) => (
          <div 
            className={cs(styles.item, styles.item_venue, (index === activeVenus) && styles.item_active)}
            onClick={() => {onSelectVenuRetry(index)
          }}>{v.venueZhName}</div>
        )}
      />
    </div>

    {/* 选择转入金额 */}
    <div>
      <div className={styles.title}>{t('dialogApply.pleaseSelectAmount')}</div>
      <input
        className={styles.input}
        type="number"
        value={prices}
        readOnly  // 只读
        onChange={(e) => {
          onChangePriceRetry(e.target.value)
        }}
        placeholder={t('dialogApply.enterAmount')}
      />
    </div>
  </div>
}

export default DialogApply